import GlobalLeaderBoard from './GlobalLeaderBoard';

export default GlobalLeaderBoard